export default class NotFoundError extends Error {
  constructor(message: string, public extra?: any) {
    super(message)

    Object.setPrototypeOf(this, NotFoundError.prototype)
  }
}
